import { useFormStatus } from 'react-dom'
import { Checkbox as UICheckbox } from 'flowbite-react'
import { Fieldset, FieldsetLabel } from '../Fieldset'
import type { FormCheckboxFieldFragment } from '../'
import { FragmentOf } from '@/graphql'

export const Checkbox = ({
  name,
  label,
  required,
  width,
  defaultChecked,
  id,
}: FragmentOf<typeof FormCheckboxFieldFragment>) => {
  const { pending } = useFormStatus()
  return (
    <Fieldset width={width} className="flex-row items-center">
      <UICheckbox
        disabled={pending}
        name={name}
        id={id!}
        color={undefined}
        required={!!required}
        defaultChecked={!!defaultChecked}
      />
      <FieldsetLabel {...{ id, required }}>{label}</FieldsetLabel>
    </Fieldset>
  )
}
